import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import DashboardLayout from './DashboardLayout';

const AdminLayout = () => {
    const location = useLocation();

    // Determine active tab from URL
    const getTabFromPath = () => {
        const path = location.pathname;
        if (path.includes('/files')) return 'files';
        if (path.includes('/startups')) return 'startups';
        if (path.includes('/investors')) return 'investors';
        if (path.includes('/users')) return 'users';
        if (path.includes('/reports')) return 'reports';
        if (path.includes('/events')) return 'events';
        if (path.includes('/settings')) return 'settings';
        if (path.includes('/account')) return 'account';
        return 'dashboard'; // default
    };

    return (
        <DashboardLayout showTabs={true} activeTab={getTabFromPath()}>
            <Outlet />
        </DashboardLayout>
    );
};

export default AdminLayout;
